import he from 'he';
import fp from 'lodash/fp';
import { pageLayouts } from '../constants';
import singleTeamCpdReport from '../reports/single-team-cpd-progress';
import { downloadBlobStreamFile, getBlobStream, getPdfStream, writeDataToPdfStream } from '../utils';

const exportSingleTeamCpdReportPdf = ({
  afsl,
  business,
  businessTeamsWithStats,
  totalTeamProgressRows,
  TeamsReportStats,
  defaultProgressLabel
}) => {
  const teamName = fp.flow(
    fp.first,
    fp.get('teamName')
  )(TeamsReportStats)
  downloadBlobStreamFile(
    writeDataToPdfStream(
      getPdfStream({
        layout: pageLayouts.landscape,
        size: 'A4'
      }),
      fp.flatMap(
        (teamWithStats) => {
          return singleTeamCpdReport({
            pageLayout: pageLayouts.landscape,
            pageSize: 'A4',
            reportee: business.name,
            afsl: afsl,
            businessTeamsWithStats,
            totalTeamProgressRows,
            teamWithStats,
            defaultProgressLabel
          })
        }
      )(TeamsReportStats)
    ).pipe(getBlobStream()), `team-cpd-activity-${he.decode(teamName)}.pdf`)
}

export default exportSingleTeamCpdReportPdf


// WEBPACK FOOTER //
// ./src/reports/export-single-team-cpd-report-pdf.js